import { FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import styles from '@common/inputFields/inputFields.module.scss';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface NameProps extends UseControllerProps {
  resetValue?: string | null;
  disabled?: boolean;
}

const Name: FC<NameProps> = (props) => {
  const { resetValue, disabled } = props;
  const { field, fieldState } = useController(props);
  const isError = fieldState.invalid;

  const onBlur = () => {
    if (!field.value) field.onChange(resetValue);
  };

  return (
    <div className={cx('nameArea')}>
      <input
        type="text"
        className={cx('input', { error: isError }, { disabled: disabled })}
        placeholder="이름을 입력해주세요."
        autoComplete="no"
        {...field}
        disabled={disabled}
        onBlur={onBlur}
      />
      {isError && <div className={cx('errorMessage')}>{fieldState.error?.message}</div>}
    </div>
  );
};

export default Name;
